module.exports = __webpack_public_path__ + "img/02_group_photo_2025.2cdcdb31.jpg";